// extracted by mini-css-extract-plugin
export default {"addToCartControl":"s0-z","giftCard":"t0-z","btnContainer":"u0-z","cartButton":"v0-z","disabled":"w0-z"};